/* Sonic theme — vanilla replacements for the original React/framer-motion islands. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveal */
  function settle(el) {
    el.style.opacity = '1';
    el.style.filter = 'none';
    el.style.transform = 'none';
    el.setAttribute('data-reveal-done', '');
  }

  function initReveals() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(settle);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function () {
            settle(el);
          }, delay);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach(function (el) {
      // Elements inside the mobile menu are revealed by the menu itself.
      if (el.getAttribute('data-reveal-trigger') === 'menu') return;
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------ hero scroll */
  /* Reproduces the source template's scroll-linked hero: over the first 800px
     the product drifts down and grows, while the headline and copy ease back.
     Values taken from the original (translate 0->280px, 200px under md;
     product scale 1->1.125; text scale 1->0.9). */
  function initHeroScroll() {
    var art = document.querySelector('[data-hero-parallax]');
    var texts = Array.prototype.slice.call(document.querySelectorAll('[data-hero-scale]'));
    if (!art && !texts.length) return;
    if (reduceMotion) return;

    var RANGE = 800;
    var started = false;
    var ticking = false;

    function at(y, from, to) {
      var t = Math.min(Math.max(y / RANGE, 0), 1);
      return from + (to - from) * t;
    }

    function update() {
      ticking = false;
      var y = window.pageYOffset || 0;

      if (!started) {
        if (y <= 5) return;
        started = true;
        // The original hands the hero over to scroll once it starts; settle the
        // entrance reveal so the two never fight over the same element.
        if (art) settle(art);
        texts.forEach(settle);
      }

      var narrow = window.innerWidth < 768;
      if (art) {
        art.style.translate = '0 ' + at(y, 0, narrow ? 200 : 280).toFixed(2) + 'px';
        art.style.scale = at(y, 1, 1.125).toFixed(4);
      }
      var shrink = at(y, 1, 0.9).toFixed(4);
      texts.forEach(function (el) { el.style.scale = shrink; });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* --------------------------------------------------------------- wordmark */
  /* The source animates each letter with a framer-motion spring
     (stiffness 100, damping 12, mass 1), 0.4s before the first letter and
     0.1s between them. We sample that spring into keyframes so the bounce —
     including the overshoot past the resting position — is reproduced exactly. */
  function springKeyframes(steps) {
    var zeta = 0.6;   // damping / (2 * sqrt(stiffness * mass)) = 12 / 20
    var w = 10;       // sqrt(stiffness / mass)
    var wd = w * Math.sqrt(1 - zeta * zeta); // damped frequency = 8
    var duration = 1.2; // seconds to settle
    var frames = [];
    for (var i = 0; i <= steps; i++) {
      var t = (duration * i) / steps;
      var x = 1 - Math.exp(-zeta * w * t) * (Math.cos(wd * t) + ((zeta * w) / wd) * Math.sin(wd * t));
      frames.push({
        offset: i / steps,
        opacity: Math.max(0, Math.min(1, x)),
        transform: 'translateY(' + (50 * (1 - x)).toFixed(2) + 'px) rotateX(' + (-90 * (1 - x)).toFixed(2) + 'deg)'
      });
    }
    return frames;
  }

  function initWordmark() {
    document.querySelectorAll('[data-wordmark]').forEach(function (group) {
      var letters = Array.prototype.slice.call(group.querySelectorAll('[data-wordmark-letter]'));
      if (!letters.length) return;

      if (reduceMotion || !('IntersectionObserver' in window) || !group.animate) {
        letters.forEach(settle);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.disconnect();
            var frames = springKeyframes(60);
            letters.forEach(function (el, i) {
              el.animate(frames, {
                duration: 1200,
                delay: 400 + i * 100,
                easing: 'linear',
                fill: 'both'
              });
            });
          });
        },
        { threshold: 0.75 } // matches the source's viewport amount
      );
      io.observe(group);
    });
  }

  /* ----------------------------------------------------- product hero scroll */
  /* Source: over the first 400px the backdrop scales 1 -> 1.1, the content
     block lifts 0 -> 180px, and the copy and CTA fade 1 -> 0. */
  function initProductHeroScroll() {
    var zoom = document.querySelector('[data-hero-zoom]');
    var lift = document.querySelector('[data-hero-lift]');
    var fades = Array.prototype.slice.call(document.querySelectorAll('[data-hero-fade]'));
    if (!zoom && !lift) return;
    if (reduceMotion) return;

    var RANGE = 400;
    var started = false;
    var ticking = false;

    function at(y, from, to) {
      var t = Math.min(Math.max(y / RANGE, 0), 1);
      return from + (to - from) * t;
    }

    function update() {
      ticking = false;
      var y = window.pageYOffset || 0;

      if (!started) {
        if (y <= 5) return;
        started = true;
        if (lift) settle(lift);
        fades.forEach(settle);
      }

      if (zoom) zoom.style.scale = at(y, 1, 1.1).toFixed(4);
      if (lift) lift.style.translate = '0 ' + at(y, 0, 180).toFixed(2) + 'px';
      var faded = at(y, 1, 0).toFixed(3);
      fades.forEach(function (el) { el.style.opacity = faded; });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ----------------------------------------------------------- pricing cards */
  /* Source: one card is always active — the middle one by default. Hovering a
     card moves the active state to it; leaving returns it to the default.
     Below the md breakpoint every card renders active. */
  function initPricingCards() {
    document.querySelectorAll('[data-pricing-grid]').forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pricing-card]'));
      if (!cards.length) return;

      var DEFAULT_INDEX = cards.length > 1 ? 1 : 0;
      var narrow = function () { return window.innerWidth < 768; };

      function apply(activeIndex) {
        var all = narrow();
        cards.forEach(function (card, i) {
          card.classList.toggle('is-active', all || i === activeIndex);
        });
      }

      cards.forEach(function (card, i) {
        card.addEventListener('mouseenter', function () { apply(i); });
        card.addEventListener('focusin', function () { apply(i); });
        card.addEventListener('mouseleave', function () { apply(DEFAULT_INDEX); });
      });
      grid.addEventListener('mouseleave', function () { apply(DEFAULT_INDEX); });
      window.addEventListener('resize', function () { apply(DEFAULT_INDEX); });

      apply(DEFAULT_INDEX);
    });
  }

  /* ------------------------------------------------------------ mobile menu */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    var overlay = menu.querySelector('[data-mobile-overlay]');
    var panel = menu.querySelector('[data-mobile-panel]');
    var art = menu.querySelector('[data-reveal-trigger="menu"]');
    var top = toggle.querySelector('[data-burger-top]');
    var bottom = toggle.querySelector('[data-burger-bottom]');
    var open = false;

    function setOpen(next) {
      open = next;
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';

      if (open) menu.classList.remove('invisible');
      overlay.classList.toggle('opacity-0', !open);
      overlay.classList.toggle('opacity-100', open);
      panel.classList.toggle('translate-x-full', !open);
      panel.classList.toggle('translate-x-0', open);
      panel.classList.toggle('opacity-0', !open);
      panel.classList.toggle('opacity-100', open);

      top.classList.toggle('-translate-y-1.5', !open);
      top.classList.toggle('rotate-45', open);
      bottom.classList.toggle('translate-y-1.5', !open);
      bottom.classList.toggle('-rotate-45', open);

      if (art) {
        if (open) {
          setTimeout(function () { settle(art); }, 200);
        } else {
          art.style.opacity = '0';
          art.style.transform = 'translateY(100px)';
          art.removeAttribute('data-reveal-done');
        }
      }

      if (!open) {
        setTimeout(function () {
          if (!open) menu.classList.add('invisible');
        }, 500);
      }
    }

    toggle.addEventListener('click', function () { setOpen(!open); });
    overlay.addEventListener('click', function () { setOpen(false); });
    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) setOpen(false);
    });
    window.addEventListener('resize', function () {
      if (open && window.innerWidth >= 768) setOpen(false);
    });
  }

  /* -------------------------------------------------------------- accordion */
  function initAccordion() {
    document.querySelectorAll('[data-accordion]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-slot="accordion-item"]'));

      function setState(item, next) {
        var trigger = item.querySelector('[data-slot="accordion-trigger"]');
        var content = item.querySelector('[data-slot="accordion-content"]');
        if (!trigger || !content) return;

        item.dataset.state = next;
        trigger.dataset.state = next;
        trigger.setAttribute('aria-expanded', String(next === 'open'));
        if (next === 'open') {
          trigger.setAttribute('aria-disabled', 'true');
        } else {
          trigger.removeAttribute('aria-disabled');
        }
        var heading = trigger.closest('h3');
        if (heading) heading.dataset.state = next;

        if (next === 'open') {
          content.hidden = false;
          content.style.setProperty('--radix-accordion-content-height', content.scrollHeight + 'px');
          content.dataset.state = 'open';
        } else {
          content.style.setProperty('--radix-accordion-content-height', content.scrollHeight + 'px');
          content.dataset.state = 'closed';
          var hide = function () {
            if (content.dataset.state === 'closed') content.hidden = true;
            content.removeEventListener('animationend', hide);
          };
          content.addEventListener('animationend', hide);
          setTimeout(hide, 260);
        }
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-slot="accordion-trigger"]');
        if (!trigger) return;
        // Prime the measured height for the item that starts open.
        if (item.dataset.state === 'open') {
          var content = item.querySelector('[data-slot="accordion-content"]');
          if (content) content.style.setProperty('--radix-accordion-content-height', content.scrollHeight + 'px');
        }
        trigger.addEventListener('click', function () {
          // Single-open and not collapsible: one item is always expanded, so
          // clicking the open item leaves it open (matches the source template).
          if (item.dataset.state === 'open') return;
          items.forEach(function (other) {
            setState(other, other === item ? 'open' : 'closed');
          });
        });
      });
    });
  }

  /* --------------------------------------------------------------- carousel */
  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-thumb]'));
      var highlight = root.querySelector('[data-carousel-highlight]');
      if (!track || !thumbs.length) return;

      var ITEM_HEIGHT = 52; // 44px thumb + 4px padding top and bottom
      var index = 0;

      function go(next) {
        index = Math.max(0, Math.min(thumbs.length - 1, next));
        track.style.transform = 'translateY(' + -index * 100 + '%)';
        if (highlight) highlight.style.setProperty('--highlight-translate-y', index * ITEM_HEIGHT + 'px');
        thumbs.forEach(function (btn, i) {
          btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (btn, i) {
        btn.addEventListener('click', function () { go(i); });
      });

      // Vertical drag, matching the cursor-grab affordance of the original.
      var startY = null;
      var viewport = root.querySelector('[data-slot="carousel"]');
      viewport.addEventListener('pointerdown', function (e) {
        startY = e.clientY;
        viewport.setPointerCapture(e.pointerId);
      });
      viewport.addEventListener('pointerup', function (e) {
        if (startY === null) return;
        var dy = e.clientY - startY;
        startY = null;
        if (Math.abs(dy) < 40) return;
        go(dy < 0 ? index + 1 : index - 1);
      });
      viewport.addEventListener('pointercancel', function () { startY = null; });

      go(0);
    });
  }

  /* ------------------------------------------------------------- blog cards */
  function initBlogCards() {
    document.querySelectorAll('[data-blog-grid]').forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-blog-card]'));
      if (!cards.length) return;

      function setActive(i) {
        cards.forEach(function (card, idx) { card.classList.toggle('is-active', idx === i); });
      }

      cards.forEach(function (card, i) {
        card.addEventListener('mouseenter', function () { setActive(i); });
        card.addEventListener('focusin', function () { setActive(i); });
      });

      setActive(cards.length > 1 ? 1 : 0);
    });
  }

  function init() {
    initReveals();
    initHeroScroll();
    initWordmark();
    initProductHeroScroll();
    initPricingCards();
    initMobileMenu();
    initAccordion();
    initCarousel();
    initBlogCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the Shopify theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
